import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Grid } from "react-md";
import { MSpinner } from "components/Shared";
import CustomerDetails from "components/Customer/Profile/CustomerDetails";
import CustomerDetailsQadDisplay from "components/QualityAssurance/CustomerQAEmployeesDisplay.tsx";
import FeaturePermissionStates from "components/Shared/FeaturePermissionStates.tsx";
import { CustomerDetailsDto } from "interfaces/Mueller.Business.Models.ts";
import FeaturePermissionTypeCodes from "typeConstants/featurePermissionCodes.ts";
import CustomerEmailCaseSettings from "components/Customer/Profile/CustomerEmailCaseSettings.tsx";
import CustomerNavigationCard from "components/Customer/Profile/CustomerNavigationCard.tsx";
import CustomerSalesDetails from "./CustomerSalesDetails.tsx";
import CustomerCalcSettingsGrid from "../CalcSettings/CustomerCalcSettingsGrid.tsx";
import CustomerExperienceAssignment from "../CustomerExperienceAssignment.tsx";
import PDFExportSettings from "./PDFExportSettings.tsx";
import CustomerInsightAccountNotificationList from "./CustomerInsightAccountNotificationList.tsx";
import { updateHeader } from "actions/layout/index.js";
import { withRouter } from "react-router";
import { HeaderDefinition } from "typeConstants/header/headerDefinitions.ts";

interface CustomerProfileProps {
  verticalDisplay: boolean;
  // redux
  history: any;
  updateHeader: (headerDefinitions: HeaderDefinition) => void;
  customerDetails: CustomerDetailsDto;
  fetchingCustomerDetails: boolean;
}

const CustomerProfile = ({
  customerDetails,
  fetchingCustomerDetails,
  verticalDisplay,
  history,
  updateHeader,
}: CustomerProfileProps) => {
  const cellWidth = verticalDisplay ? 12 : 6;

  useEffect(() => {
    if (verticalDisplay) return;

    updateHeader({
      buttons: [{
        name: "Back to Customer List",
        onClick: () => history.goBack(),
      }]
    });

    return () => {
      updateHeader({ buttons: []});
    };
  }, [verticalDisplay]); 

  if (fetchingCustomerDetails) return (<MSpinner />);

  if (!customerDetails) return (<div>No Customer Selected. Please select a customer in Maintenance {">"} Account List and view details in full screen</div>);

  return (
    <Grid>
      <CustomerDetails cellWidth={cellWidth} />
      <CustomerSalesDetails customerNumber={customerDetails?.number} cellWidth={cellWidth} />
      <CustomerInsightAccountNotificationList customerNumber={customerDetails?.number} verticalDisplay={verticalDisplay} />
      <CustomerDetailsQadDisplay cellWidth={cellWidth} />
      <CustomerExperienceAssignment verticalDisplay={verticalDisplay} customerNumber={customerDetails?.number} />
      <CustomerEmailCaseSettings verticalDisplay={verticalDisplay} />
      <FeaturePermissionStates
        cellWidth={cellWidth}
        customerNumber={customerDetails?.number}
        featurePermissionType={FeaturePermissionTypeCodes.CALL_CENTER_INCLUSION}
      />
      <CustomerNavigationCard 
        customerNumber={customerDetails?.number}
        verticalDisplay={verticalDisplay}
      />
      <CustomerCalcSettingsGrid customerNumber={customerDetails?.number} verticalDisplay={verticalDisplay} />
      <PDFExportSettings customerNumber={customerDetails?.number} cellWidth={cellWidth} />
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  customerDetails: state.customer.customerDetails,
  fetchingCustomerDetails: state.customer.fetchingCustomerDetails,
});

const mapDispatchToProps = (dispatch) => ({
  updateHeader(headerDefinitions: HeaderDefinition) {
    dispatch(updateHeader(headerDefinitions));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerProfile));